import { AU } from '@/core/units';
import { DEG } from '@/core/math/scalar';
import { OrbitalElements } from '../OrbitalElements';

/** Builds heliocentric elements from astronomical units and degrees. */
export function orbitAU(
  semiMajorAxisAU: number,
  eccentricity: number,
  inclinationDeg: number,
  ascendingNodeDeg: number,
  argumentOfPeriapsisDeg: number,
  meanAnomalyDeg: number,
): Omit<OrbitalElements, 'mu'> {
  return {
    semiMajorAxis: semiMajorAxisAU * AU,
    eccentricity,
    inclination: inclinationDeg * DEG,
    ascendingNode: ascendingNodeDeg * DEG,
    argumentOfPeriapsis: argumentOfPeriapsisDeg * DEG,
    meanAnomalyAtEpoch: meanAnomalyDeg * DEG,
    epoch: 0,
  };
}

/** Builds planet-relative elements from kilometres and degrees. */
export function orbitKm(
  semiMajorAxisKm: number,
  eccentricity: number,
  inclinationDeg: number,
  ascendingNodeDeg: number,
  argumentOfPeriapsisDeg: number,
  meanAnomalyDeg: number,
): Omit<OrbitalElements, 'mu'> {
  return {
    semiMajorAxis: semiMajorAxisKm * 1000,
    eccentricity,
    inclination: inclinationDeg * DEG,
    ascendingNode: ascendingNodeDeg * DEG,
    argumentOfPeriapsis: argumentOfPeriapsisDeg * DEG,
    meanAnomalyAtEpoch: meanAnomalyDeg * DEG,
    epoch: 0,
  };
}

export const HOURS = 3600;
